import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import React from "react";
import { Subheading } from "src/components/base/heading";
import { ACL } from "src/components/acl";
import SINGLE_DEVICE_GROUP_CONTEXT from "src/context/internal/device-group";
import ReadOnlyRuleSets from "src/components/rulesets";

/**
 * The properties for {@link DeviceGroupInboundACLs}
 */
export type DeviceGroupInboundACLsProps = {};

/**
 * The view to display the Inbound ACLs of a device group
 */
function DeviceGroupInboundACLs(props: DeviceGroupInboundACLsProps) {
    const [t] = useTranslation("admin-device-group");

    const ctx = React.useContext(SINGLE_DEVICE_GROUP_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            <Subheading>{t("heading.add-new-acl")}</Subheading>
            <ACL
                key={"new-inbound"}
                onChange={ctx.reset}
                dst={{ type: "DeviceGroup", value: ctx.deviceGroup }}
                startEditable={true}
            />

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.deviceGroup.access_rules.inbound.map((acl) => (
                <ACL key={acl.uuid} dst={acl.dst} acl={acl} onChange={ctx.reset} />
            ))}

            <Subheading>{t("heading.rulesets")}</Subheading>
            {ctx.deviceGroup.rulesets.inbound.map((ruleset) => (
                <ReadOnlyRuleSets
                    key={ruleset.uuid}
                    name={ruleset.name}
                    description={ruleset.description}
                    rules={ruleset.rules}
                    destinations={ruleset.src_or_dst}
                />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/devicegroups/$deviceGroupId/_devicegroups/inbound-acls")({
    component: DeviceGroupInboundACLs,
});
